export const defaultProactiveChatPaneBodyContainerStyles = {};